import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    field: {
        marginTop: 6,
        marginBottom: theme.spacing(2),
    },
    helperText: {
        position: 'absolute',
        top: '54px',

        fontSize: '14px',
        lineHeight: '14px',
    },
    label: {
        whiteSpace: 'nowrap',
    },
}));
